import Modal from "../Modal";
import ProductConfigurationForm from "../../forms/product/ProductConfigurationForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function ProductConfigurationModal({
  show,
  handleClose,
  onSelect,
  product,
  title,
}) {
  const { t } = useTranslation();
  return (
    <Modal title={title} show={show} handleClose={handleClose} width="700px">
      <ProductConfigurationForm
        handleClose={handleClose}
        product={product}
        onSelect={onSelect}
      />
    </Modal>
  );
}
